import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Roofwaterproofingsheets() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>    יריעות איטום לגג  </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Bituminoussheets">   יריעות ביטומניות</Link>/{" "}
    <Link to="/Roofwaterproofingsheets">  יריעות איטום לגג  </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
        הדרך המקובלת כיום לאטום גגות, היא באמצעות יריעות איטום לגג. סוג יריעות שמרבים לאטום בהן כיום את הגג, הן יריעות איטום ביטומניות. אולם, בשוק ישנן סוגים נוספים של יריעות איטום. במאמר, ננסה להכיר מעט את סוגי היריעות השונות המשמשים לאיטום. אנו נלמד גם אילו סוגי יריעות מתאימות לאיטום המתבצע מתחת לגג רעפים.
    </h2>




   <h2 className="main-title">
סקירה קצרה על יריעות ביטומניות:
    </h2>
    <div className="content-row">

      <div className="image-box">
        <img src="/images/61.jpg" alt="roof" />
      </div>
      <div className="text-box">
        <p>חברות האיטום המקצועיות, מעדיפות לאטום את הגג באמצעות יריעות איטום ביטומניות של חברת ביטום. יריעות אלו מכילות פולימרים שונים. ישנן יריעות ביטומניות המתבססות על פולימר APP, וישנן יריעות המתבססות על חומר SBS. ישנן יריעות איטום ביטומניות מיוחדות, המתאימות לגג רעפים. יריעות אלו הינן אלסטיות, וניתנות להדבקה. עבור חצרות וחניונים, יש יריעות ביטומניות מיוחדות, המונעות חדירת שורשי עץ אל היריעה.</p>

    <h2 className="main-title">
כיצד נראות יריעות איטום?


    </h2>
        <p>          איטום גגות ביריעות ביטומניות, או לכל שימוש אחר, מגיעות בצורת גליל, ונמצאות בתוך קופסא ארוזה. בדרך כלל, היריעות הן ברוחב מטר. אורכי היריעות משתנים. יהיו יריעות באורכי 7 מטר, ויהיו יריעות באורך 10 מטר. הצוות המבצע את פעולת האיטום, חותך את היריעות לפי האורך הרצוי. כאשר אוטמים מרפסות, יהיה צורך באורך יריעה קצר יותר. בדרך כלל, ליריעות האיטום יש 2 סוגי גוונים: הצבע הנפוץ לשימוש בגגות, הוא יריעות בצבע לבן. הסיבה לכך, היא שהצבע הלבן מחזיר את קרני השמש. הצבע השני, הוא יריעות בצבע שחור. יריעות בצבע שחור מתאימות לחיפוי קירות, או קרקע חנייה.             </p>



      </div>




    </div>

    <h2 className="main-title">
באילו יריעות איטום כדאי להשתמש עבור גג רעפים?


    </h2>

    <div className="bottom-text">
      <p>עבודת איטום גג רעפים, הינה עבודה מורכבת יותר, מאשר איטום גג רגיל. בעוד עבודת איטום גג רגיל נעשית תחת השמש, וניתן להיעזר באש לצורך הדבקת היריעות- הרי שבגג רעפים העבודה יותר מוגבלת. לא ניתן לחמם אש בגג רעפים. לכן, יש צורך להשתמש ביריעות איטום לגג הנדבקות מעצמן. יריעות איטום המתאימות לכך, הן יריעות "אלסטוטייט". אלו הן יריעות אלסטיות, אשר הדבק בהן חזק מאוד, וניתן להדביק אותן בקלות, וללא השקעת מאמץ</p>

    <h2 className="main-title">
יריעות איטום "ביטוגלס":

    </h2>

      <p>סוג נוסף של יריעות איטום המתאימות לגג רעפים, הן יריעות איטום "ביטוגלס". יריעות אלו, דקות יותר מיריעות איטום ביטומניות רגילות. לכן, מומלץ להשתמש ביריעות אלו, בשילוב עם מריחת חומר איטום. היריעה מצופה מעל ומתחת בלבד זכוכית, על מנת ליצור את ההגנה המושלמת מעל היריעה. ציפוי הזכוכית, נותן הגנה ליריעה מפני הלחות והעובש השוררים מתחת לגג הרעפים.</p>




    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Waterproofingroofswithbituminoussheets" className="link-right" >איטום גגות ביריעות ביטומניות </Link>
  <Link to="/Types_of_bituminous_sheets" className="link-left" > סוגי יריעות ביטומניות   </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

